<dx-data-grid
  [dataSource]="dataSource()"
  [showBorders]="true"
  [showRowLines]="true"
  [showColumnLines]="true"
  [wordWrapEnabled]="true"
  [rowAlternationEnabled]="true"
  [allowColumnResizing]="true"
  data-testid="task-history-grid">
  
  <dxo-paging [pageSize]="10"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
  <dxo-header-filter [visible]="true"></dxo-header-filter>
  
  <dxi-column dataField="task" caption="Task Id" dataType="string" width="10%"></dxi-column>
  <dxi-column dataField="name" caption="Task Type" dataType="string" width="15%" cellTemplate="noWrapTemplate"></dxi-column>
  <dxi-column dataField="column" caption="Column" dataType="string" width="10%" cellTemplate="noWrapTemplate"></dxi-column>
  <dxi-column dataField="oldValue" caption="Old Value" dataType="string" width="20%" cellTemplate="formattedValueTemplate"></dxi-column>
  <dxi-column dataField="newValue" caption="New Value" dataType="string" width="20%" cellTemplate="formattedValueTemplate"></dxi-column>
  <dxi-column dataField="updatedByName" caption="Updated By" dataType="string" width="10%"></dxi-column>
  <dxi-column dataField="updatedTimestamp" caption="Updated Date" dataType="datetime" width="15%"></dxi-column>

  <div *dxTemplate="let cellData of 'noWrapTemplate'">
    <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" [title]="cellData.value">
      {{ cellData.value }}
    </div>
  </div>

  <div *dxTemplate="let cellData of 'formattedValueTemplate'">
    <div [ngClass]="{'formatted-json': isJson(cellData.value), 'formatted-html': isHtml(cellData.value)}">
      @if (isJson(cellData.value)) {
        <pre style="margin: 0; white-space: pre-wrap; font-family: monospace; font-size: 12px;">{{ formatValue(cellData.value) }}</pre>
      }
      @else if (isHtml(cellData.value)) {
        <div style="font-family: monospace; font-size: 12px; color: #666;">{{ cellData.value }}</div>
      }
      @else {
        <span>{{ cellData.value }}</span>
      }
    </div>
  </div>

</dx-data-grid>
